import vm from "../main";
import axios from "./PointrCloudAxios";
import Helpers from "@/helpers/Helpers";

export default class LevelService {
  static async getLevels(buildingInternalIdentifier) {
    let response;
    let levels;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/buildings/${buildingInternalIdentifier}/levels/draft`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    levels = response?.data?.results?.sort(Helpers.sortContent);
    return levels;
  }

  static async getLevel(buildingInternalIdentifier, levelIndex) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/buildings/${buildingInternalIdentifier}/levels/${levelIndex}/draft`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data?.result;
  }

  static async createLevel(buildingInternalIdentifier, levelIndex, level) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`/buildings/${buildingInternalIdentifier}/levels/${levelIndex}`, level);
    } catch (error) {
      console.error(error);
      return error?.response?.data?.error;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async updateLevel(buildingInternalIdentifier, levelIndex, level) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.patch(`/buildings/${buildingInternalIdentifier}/levels/${levelIndex}`, level);
    } catch (error) {
      console.error(error);
      return error?.response?.data?.error;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async deleteLevel(buildingInternalIdentifier, levelIndex) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.delete(`/buildings/${buildingInternalIdentifier}/levels/${levelIndex}`);
    } catch (error) {
      console.error(error);
      return error?.response?.data?.error;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }

  static async bulkUpload(siteInternalIdentifier, buildingInternalIdentifier, levelIndex, featureCollection) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    // TODO: Move this task to somewehere else?
    // generate fid for each feature
    // add default typeCode if there isn't one
    featureCollection.features = featureCollection.features.map((feature) => {
      if (feature.properties.fid === undefined || feature.properties.fid === "") {
        feature.properties.fid = Helpers.generateUuid();
      }
      if (feature.properties.typeCode === undefined || feature.properties.typeCode === "") {
        feature.properties.typeCode = "undefined";
      }
      feature.properties.bid = Number(buildingInternalIdentifier);
      feature.properties.sid = Number(siteInternalIdentifier);
      feature.properties.lvl = Number(levelIndex);
      return feature;
    });
    try {
      response = await axios.post(
        `/buildings/${buildingInternalIdentifier}/levels/${levelIndex}/bulk`,
        featureCollection
      );
    } catch (error) {
      response = error.response;
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }
}
